import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  Link,
  Center,
} from "@chakra-ui/react";
import { MdPhone, MdEmail, MdLocationOn, MdOutlineEmail } from "react-icons/md";
import { BsPerson } from "react-icons/bs";
import { ImLinkedin } from "react-icons/im";
import { HiOutlineMail } from "react-icons/hi";
import { FaGithub } from "react-icons/fa";
import emailjs from "emailjs-com";
import { useToast } from "@chakra-ui/react";

export default function Contact() {
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await emailjs
      .sendForm(
        "service_d9bstxg",
        "template_jqgvcgc",
        e.target,
        "3gU0Kb2wAivAw6k4J"
      )
      .then(
        (result) => {
          toast({
            title: "Message send Successfully.",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  return (
    <Container maxW="full" mt={0} centerContent overflow="hidden" id="contact">
      <Flex>
        <Box
          bg="#1a202c"
          color="white"
          borderRadius="lg"
          m={{ sm: 4, md: 16, lg: 10 }}
          p={{ sm: 5, md: 5, lg: 16 }}
          border={"1px solid white"}
        >
          <Box p={4}>
            <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
              <WrapItem>
                <Box>
                  <Heading>Contact</Heading>
                  <Text mt={{ sm: 3, md: 3, lg: 5 }} color="gray.500">
                    Fill up the form below to contact
                  </Text>
                  <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                    <VStack pl={0} spacing={3} alignItems="flex-start">
                      <Button
                        size="md"
                        id="contact-phone"
                        height="48px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "2px solid #81e6d9" }}
                        leftIcon={<MdPhone color="#81e6d9" size="20px" />}
                      >
                        +91-7503089366
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        color="#DCE2FF"
                        id="contact-email"
                        _hover={{ border: "2px solid #81e6d9" }}
                        leftIcon={<MdEmail color="#81e6d9" size="20px" />}
                      >
                        ajay9679339@gmail.com
                      </Button>
                      <Button
                        size="md"
                        height="48px"
                        variant="ghost"
                        color="#DCE2FF"
                        _hover={{ border: "2px solid #81e6d9" }}
                        leftIcon={<MdLocationOn color="#81e6d9" size="20px" />}
                      >
                        New Delhi, India
                      </Button>
                    </VStack>
                  </Box>
                  <HStack
                    mt={{ lg: 10, md: 10 }}
                    spacing={5}
                    px={5}
                    alignItems="flex-start"
                  >
                    <Link
                      id="contact-linkedin"
                      href="https://www.linkedin.com/in/ajay-84sia/"
                      isExternal
                      _hover={{ color: "#81e6d9" }}
                    >
                      <ImLinkedin fontSize={"1.6rem"} />
                    </Link>
                    <Link
                      id="contact-github"
                      href="https://github.com/Ajay84sia"
                      isExternal
                      _hover={{ color: "#81e6d9" }}
                    >
                      <FaGithub fontSize={"1.6rem"} />
                    </Link>
                    <Link
                      id="contact-email"
                      href="mailto:ajay9679339@gmail.com"
                      isExternal
                      _hover={{ color: "#81e6d9" }}
                    >
                      <HiOutlineMail fontSize={"1.8rem"} />
                    </Link>
                    <Link
                      id="contact-phone"
                      href="tel:+917503089366"
                      isExternal
                      _hover={{ color: "#81e6d9" }}
                    >
                      <MdPhone fontSize={"1.7rem"} />
                    </Link>
                  </HStack>
                </Box>
              </WrapItem>
              <WrapItem>
                <Box bg="#1a202c" borderRadius="lg">
                  <Box m={8}>
                    <VStack spacing={5}>
                      <form onSubmit={handleSubmit}>
                        <FormControl id="name">
                          <FormLabel>Name</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={<BsPerson color="gray.800" />}
                            />
                            <Input
                              name="user_name"
                              required
                              borderColor={"teal"}
                              type="text"
                              placeholder="Enter your name"
                              size="md"
                            />
                          </InputGroup>
                        </FormControl>
                        <FormControl id="name">
                          <FormLabel>Mail</FormLabel>
                          <InputGroup borderColor="#E0E1E7">
                            <InputLeftElement
                              pointerEvents="none"
                              children={<MdOutlineEmail color="gray.800" />}
                            />
                            <Input
                              name="user_email"
                              required
                              borderColor={"teal"}
                              type="email"
                              placeholder="Enter you email"
                              size="md"
                            />
                          </InputGroup>
                        </FormControl>
                        <FormControl id="name">
                          <FormLabel>Message</FormLabel>
                          <Textarea
                            name="message"
                            required
                            borderColor={"teal"}
                            _hover={{
                              borderRadius: "gray.300",
                            }}
                            placeholder="message"
                          />
                        </FormControl>
                        <FormControl id="name" float="right">
                          <Button
                            width={"100%"}
                            type="submit"
                            marginTop={"15px"}
                            colorScheme={"teal"}
                            _hover={{ boxShadow: "lg" }}
                          >
                            Send Message
                          </Button>
                        </FormControl>
                      </form>
                    </VStack>
                  </Box>
                </Box>
              </WrapItem>
            </Wrap>
          </Box>
        </Box>
      </Flex>
      <Center paddingBottom={"5px"} textAlign={"center"}>
        <footer>
          Designed and built with ❤️ by &nbsp;
          <a
            href="https://www.linkedin.com/in/ajay-84sia/"
            target="_blank"
            rel="noreferrer"
            fontWeight="bolder"
            fontSize={"larger"}
          >
            🅰🅹🅰🆈
          </a>
          &nbsp; © 2023. <br />
          All rights reserved
        </footer>
      </Center>
    </Container>
  );
}
//   <IconButton
//   aria-label="LinkedIn"
//   variant="ghost"
//   size="lg"
//   isRound={true}
//   _hover={{ bg: '#0D74FF' }}
//   icon={<ImLinkedin size="28px" />}
// />
// <IconButton
//   aria-label="github"
//   variant="ghost"
//   size="lg"
//   isRound={true}
//   _hover={{ bg: '#0D74FF' }}
//   icon={<BsGithub size="28px" />}
// />
// <IconButton
//   aria-label="discord"
//   variant="ghost"
//   size="lg"
//   isRound={true}
//   _hover={{ bg: '#0D74FF' }}
//   icon={<HiOutlineMail size="28px" />}
// />
